import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import Tooltip from '../../components/Tooltip';
import { numberFormatterWithEmptySpaceWhenFalsy } from '../../utils/formatters';
import { NameCell } from './NameCell.css';
// TODO - add tests for createTooltip and createValue
const MergedColumn = memo(({ targetColumn, inheritWidth, typeAlignment, item }) => {
    return (_jsx(Tooltip, Object.assign({ title: createToolTip(item[targetColumn.name], targetColumn.type, targetColumn.mergeWith, item, targetColumn.mergeDelimiter) }, { children: _jsx(NameCell, Object.assign({ inheritWidth: inheritWidth, typeAlignment: typeAlignment }, { children: createValue(item[targetColumn.name], targetColumn.type, targetColumn.mergeWith, item, targetColumn.mergeSingleLetterColumn, targetColumn.mergeDelimiter) })) })));
});
const singleLetterValue = (value) => value[0];
const createToolTip = (targetColumn, targetColumnType, mergeColumns, item, delimiter) => formatTargetColumn(targetColumnType, targetColumn) +
    ' ' +
    (mergeColumns === null || mergeColumns === void 0 ? void 0 : mergeColumns.map((column) => { var _a; return (_a = item[column]) !== null && _a !== void 0 ? _a : '-'; }).join(delimiter !== null && delimiter !== void 0 ? delimiter : ''));
const createValue = (targetColumn, targetColumnType, mergeColumns, item, singleLetterColumns, delimiter) => targetColumn
    ? formatTargetColumn(targetColumnType, targetColumn) +
        ' ' +
        (mergeColumns === null || mergeColumns === void 0 ? void 0 : mergeColumns.map((column) => {
            if (item[column] != null) {
                if (singleLetterColumns === null || singleLetterColumns === void 0 ? void 0 : singleLetterColumns.includes(column)) {
                    return singleLetterValue(item[column]);
                }
                return item[column];
            }
            return '-';
        }).join(delimiter !== null && delimiter !== void 0 ? delimiter : ' '))
    : '';
const formatTargetColumn = (targetColumnType, targetColumnValue) => targetColumnType === 'Number' || targetColumnType === 'Price'
    ? numberFormatterWithEmptySpaceWhenFalsy(targetColumnValue)
    : targetColumnValue;
export default MergedColumn;
